module.exports = __webpack_public_path__ + "img/insta-red.2102a1dc.svg";